<app-categories-tree-table [categories]="categories" *ngIf="categories" />
